import React from 'react';
import { bool, func, node, string } from 'prop-types';
import classNames from 'classnames';

import './style.scss';

const ItemTab = ({ name, title, isActive = false, onClick = Function.prototype }) => (
    <button className={classNames('item-tab', 'text-body-default', { active: isActive })} onClick={() => onClick(name)}>
        {title}
    </button>
);

ItemTab.propTypes = {
    name: string,
    title: node,
    isActive: bool,
    onClick: func,
};

export default ItemTab;
